import BaseOnboardingService from "./baseOnboarding.service";

class TypeUnaivalabilityService extends BaseOnboardingService {
  constructor() {
    super("type-unaivalability");
  }
}

export default new TypeUnaivalabilityService();
